import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SequenceService {
  private baseUrl = `${environment.apiUrl}/api/sequences`   ;

  constructor(
    private http: HttpClient
  ) {}

  async generate(
    entity: string,
    orgId?: string,
    branchId?: string
  ): Promise<string> {

    let url =
      `${this.baseUrl}/next/${entity}`;

    const params: string[] = [];

    if (orgId)
      params.push(`orgId=${orgId}`);

    if (branchId)
      params.push(`branchId=${branchId}`);

    if (params.length)
      url += `?${params.join('&')}`;

    const res: any =
      await firstValueFrom(
        this.http.get(url)
      );

    return res?.value || '';
  }

  async preview(
    entity: string,
    orgId?: string,
    branchId?: string
  ): Promise<string> {

    let url =
      `${this.baseUrl}/preview/${entity}`;

    const params: string[] = [];

    if (orgId)
      params.push(`orgId=${orgId}`);

    if (branchId)
      params.push(`branchId=${branchId}`);

    if (params.length)
      url += `?${params.join('&')}`;

    const res: any =
      await firstValueFrom(
        this.http.get(url)
      );

    return res?.value || '';
  }

  // preview(
  //   entity: string,
  //   orgId?: string,
  //   branchId?: string
  // ) {

  //   return this.http.get<any>(
  //     `${this.baseUrl}/preview/${entity}`,
  //     {
  //       params: {
  //         orgId: orgId || '',
  //         branchId: branchId || ''
  //       }
  //     }
  //   );
  // }

}